var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.flightdirection === "outward"
        ? _c("h2", [
            _vm._v(
              _vm._s(
                _vm.tab_header_flightdetailsoutwardservices[
                  _vm.getCurrentLocale
                ]
              ) + ":"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.flightdirection === "return"
        ? _c("h2", [
            _vm._v(
              _vm._s(
                _vm.tab_header_flightdetailsreturnservices[_vm.getCurrentLocale]
              ) + ":"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "intro table-wrapper full-width hidden-table-sm box",
          staticStyle: { "border-spacing": "8px" },
        },
        [
          _c("div", { staticClass: "col-md-4 table-cell sdr-box" }, [
            _c("dl", { staticClass: "term-description" }, [
              _c("dt", [
                _vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale]) + ":"),
              ]),
              _c("dd", [_vm._v("Schauinsland")]),
              _vm._v(" "),
              _c("dt", [
                _vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale]) + ":"),
              ]),
              _c("dd", [_vm._v("Economy")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 table-cell" }, [
            _c("div", { staticClass: "detailed-features booking-details" }, [
              _c("div", { staticClass: "sdr-box" }, [
                _vm.flightdirection === "outward"
                  ? _c("h4", { staticClass: "box-title" }, [
                      _vm._v(
                        _vm._s(_vm.from[_vm.getCurrentLocale]) +
                          " " +
                          _vm._s(
                            _vm.get_ServicesBookingnoDepArprtNameOutuward
                          ) +
                          " " +
                          _vm._s(_vm.to[_vm.getCurrentLocale]) +
                          "  " +
                          _vm._s(_vm.get_ServicesBookingnoDesArprtNameOutward)
                      ),
                      _c("small", [
                        _vm._v(_vm._s(_vm.outwardflight[_vm.getCurrentLocale])),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.flightdirection === "return"
                  ? _c("h4", { staticClass: "box-title" }, [
                      _vm._v(
                        _vm._s(_vm.from[_vm.getCurrentLocale]) +
                          " " +
                          _vm._s(_vm.get_ServicesBookingnoDepArprtNameReturn) +
                          " " +
                          _vm._s(_vm.to[_vm.getCurrentLocale]) +
                          "  " +
                          _vm._s(_vm.get_ServicesBookingnoDesArprtNameReturn)
                      ),
                      _c("small", [
                        _vm._v(_vm._s(_vm.returnflight[_vm.getCurrentLocale])),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-wrapper flights" }, [
                _c("div", { staticClass: "table-row first-flight" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-cell timing-detail" }, [
                    _c("div", { staticClass: "timing" }, [
                      _c("div", { staticClass: "check-in" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale])),
                        ]),
                        _vm._v(" "),
                        _vm.flightdirection === "outward"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.get_ServicesBookingnoSearchResults[0]
                                      .outwardFlight.departureDateTimeLocal
                                  )
                                ) +
                                  ", " +
                                  _vm._s(
                                    _vm._f("momentTime")(
                                      _vm.get_ServicesBookingnoSearchResults[0]
                                        .outwardFlight.departureDateTimeLocal
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flightdirection === "return"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.get_ServicesBookingnoSearchResults[0]
                                      .returnFlight.departureDateTimeLocal
                                  )
                                ) +
                                  ", " +
                                  _vm._s(
                                    _vm._f("momentTime")(
                                      _vm.get_ServicesBookingnoSearchResults[0]
                                        .returnFlight.departureDateTimeLocal
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "duration text-center" }, [
                        _c("i", { staticClass: "soap-icon-clock" }),
                        _vm._v(" "),
                        _vm.flightdirection === "outward"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("durationFlightCart")(
                                    _vm.get_ServicesBookingnoSearchResults[0]
                                      .outwardFlight.dur
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flightdirection === "return"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("durationFlightCart")(
                                    _vm.get_ServicesBookingnoSearchResults[0]
                                      .returnFlight.dur
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "check-out" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale])),
                        ]),
                        _vm._v(" "),
                        _vm.flightdirection === "outward"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.get_ServicesBookingnoSearchResults[0]
                                      .outwardFlight.destinationDateTimeLocal
                                  )
                                ) +
                                  ", " +
                                  _vm._s(
                                    _vm._f("momentTime")(
                                      _vm.get_ServicesBookingnoSearchResults[0]
                                        .outwardFlight.destinationDateTimeLocal
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flightdirection === "return"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.get_ServicesBookingnoSearchResults[0]
                                      .returnFlight.destinationDateTimeLocal
                                  )
                                ) +
                                  ", " +
                                  _vm._s(
                                    _vm._f("momentTime")(
                                      _vm.get_ServicesBookingnoSearchResults[0]
                                        .returnFlight.destinationDateTimeLocal
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._l(
        _vm.get_ServicesBookingnoSearchResultsPassengersSorted,
        function (pax, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "booking-section sdr-box",
              staticStyle: { padding: "0px", "padding-top": "10px" },
            },
            [
              _c("h4", { staticClass: "paxheadline" }, [
                _vm._v(
                  _vm._s(_vm.trnslPaxSalutations(pax.salutation)) +
                    " " +
                    _vm._s(pax.firstName) +
                    " " +
                    _vm._s(pax.lastName) +
                    " (" +
                    _vm._s(_vm.born[_vm.getCurrentLocale]) +
                    ": " +
                    _vm._s(_vm._f("birthdate")(pax.birthdate)) +
                    ")"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-cell cruise-itinerary" }, [
                _c(
                  "div",
                  {
                    staticClass: "sdr-box",
                    staticStyle: {
                      "padding-top": "0px",
                      "padding-bottom": "0px",
                      "padding-left": "0px",
                      "padding-right": "0px",
                    },
                  },
                  [
                    _vm.flightdirection === "outward"
                      ? _c("table", [
                          _c(
                            "tbody",
                            [
                              _c("tr", [
                                _c("td", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.flightpriceservices[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(" ")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "total-price-value-small" },
                                  [_vm._v(" - ")]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.getSeatData(pax.outboundServices).length > 0
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.seat[_vm.getCurrentLocale]) +
                                          ": "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("truncate")(
                                              _vm.getSeatData(
                                                pax.outboundServices
                                              )[0].seatName.seatName,
                                              17,
                                              "..."
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(" ")]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("rndAmntRUAFWZ")(
                                              _vm.getSeatData(
                                                pax.outboundServices
                                              )[0].price !== undefined
                                                ? _vm.getSeatData(
                                                    pax.outboundServices
                                                  )[0].price
                                                : "0"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                pax.outboundServices.filter(function (x) {
                                  return x.code != "SEAT"
                                }),
                                function (srvcs, index2) {
                                  return _c("tr", { key: index2 }, [
                                    _c("td", [_vm._v(_vm._s(srvcs.label))]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "text-transform": "none",
                                        },
                                      },
                                      [
                                        srvcs.quantity > 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(srvcs.quantity) +
                                                  "x a " +
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      srvcs.price
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("rndAmntRUAFWZ")(
                                              srvcs.price !== undefined
                                                ? parseFloat(srvcs.price) *
                                                    parseFloat(srvcs.quantity)
                                                : "0"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.flightdirection === "return"
                      ? _c("table", [
                          _c(
                            "tbody",
                            [
                              _c("tr", [
                                _c("td", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.flightpriceservices[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(" ")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "total-price-value-small" },
                                  [_vm._v(" - ")]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.getSeatData(pax.inboundServices).length > 0
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.seat[_vm.getCurrentLocale]) +
                                          ": "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("truncate")(
                                              _vm.getSeatData(
                                                pax.inboundServices
                                              )[0].seatName.seatName,
                                              17,
                                              "..."
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(" ")]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("rndAmntRUAFWZ")(
                                              _vm.getSeatData(
                                                pax.inboundServices
                                              )[0].price !== undefined
                                                ? _vm.getSeatData(
                                                    pax.inboundServices
                                                  )[0].price
                                                : "0"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                pax.inboundServices.filter(function (x) {
                                  return x.code != "SEAT"
                                }),
                                function (srvcs, index2) {
                                  return _c("tr", { key: index2 }, [
                                    _c("td", [_vm._v(_vm._s(srvcs.label))]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "text-transform": "none",
                                        },
                                      },
                                      [
                                        srvcs.quantity > 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(srvcs.quantity) +
                                                  "x a " +
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      srvcs.price
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("rndAmntRUAFWZ")(
                                              srvcs.price !== undefined
                                                ? parseFloat(srvcs.price) *
                                                    parseFloat(srvcs.quantity)
                                                : "0"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-cell logo" }, [
      _c("img", {
        staticStyle: { "padding-bottom": "3px" },
        attrs: { src: "/res/images/sdr140x30.png", alt: "Schauinsland" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }